import { DrinksIndexer, DrinksDescription } from "@dcc/types/drinks";
import { Gender } from "@dcc/types/gender";
import { UnitAndCalories } from "@dcc/types/drinkingDay";
import { dictionary } from "@dcc/lookup/dictionary/dictionary";

export const MIN_DRINKS = 0;
export const MAX_DRINKS = 99;

export const drinkUnitAndCalories: DrinksIndexer<UnitAndCalories> = {
  beer: {
    units: 1.6,
    calories: 142
  },
  pint: {
    units: 2.3,
    calories: 181
  },
  wine: {
    units: 2.3,
    calories: 158.2
  },
  spirit: {
    units: 1,
    calories: 55.5
  }
};

export const CHEESEBURGER_CALORIES = 303;
export const SLIDER_CALORIES_PER_UNIT = 61;

export const maxWeeklyDrinks = {
  [Gender.Male]: 50,
  [Gender.Female]: 35
};

export const maxUnitsPerDay = {
  [Gender.Male]: 8,
  [Gender.Female]: 6
};

export const NO_RISK_WEEKLY_UNITS = 14;

export const drinkToNumber: DrinksIndexer<number> = {
  beer: 0,
  wine: 1,
  pint: 2,
  spirit: 3
};

export const getDrinkDescriptions = (): DrinksDescription => ({
  beer: {
    title: dictionary.Tools_General_Beer,
    description: dictionary.Tools_General_Bottle330
  },
  pint: {
    title: dictionary.Tools_General_Pint,
    description: dictionary.Tools_General_BeerCider
  },
  wine: {
    title: dictionary.Tools_General_Wine,
    description: dictionary.Tools_General_MediumGlass
  },
  spirit: {
    title: dictionary.Tools_General_Spirit,
    description: dictionary.Tools_General_SingleMeasure
  }
});
